module.exports = __webpack_public_path__ + "static/media/preferences.b287b8e5.svg";